import { LegalBlock } from '@components/legal/legalTypes';

// Single source of truth for IMPRV.AI's registration data, reused across the legal
// documents and the landing-page footer. Only invariant values live here; each document
// keeps its own surrounding phrasing (some spell the court out, some abbreviate to "KRS",
// the privacy policy writes "Pl. Solny", etc.), so those variants stay in place.
export const COMPANY = {
  legalNameShort: 'IMPRV.AI sp. z o.o.',
  legalNameFull: 'IMPRV.AI spółka z ograniczoną odpowiedzialnością',
  street: 'Plac Solny 15',
  postalCity: '50-062 Wrocław',
  city: 'Wrocław',
  nip: '8982307269',
  regon: '528503152',
  krs: '0001103280',
  shareCapital: '44 000 zł',
  email: 'hello@imprv.ai',
  courtFull:
    'Sąd Rejonowy dla Wrocławia-Fabrycznej we Wrocławiu, VI Wydział Gospodarczy Krajowego Rejestru Sądowego',
  courtShort: 'Sąd Rejonowy dla Wrocławia-Fabrycznej we Wrocławiu, VI Wydział Gospodarczy KRS'
} as const;

// Inline link marker for the contact e-mail (the renderer expands [[label|href]]).
export const COMPANY_EMAIL_LINK = `[[${COMPANY.email}|mailto:${COMPANY.email}]]`;

// Standalone company-identity paragraphs, as shown on the contact page.
export const companyIdentityBlocks: LegalBlock[] = [
  { kind: 'paragraph', text: `**${COMPANY.legalNameShort}**` },
  { kind: 'paragraph', text: `${COMPANY.street}, ${COMPANY.postalCity}` },
  { kind: 'paragraph', text: `NIP: ${COMPANY.nip}` },
  { kind: 'paragraph', text: `REGON: ${COMPANY.regon}` },
  { kind: 'paragraph', text: `KRS: ${COMPANY.krs}` }
];
